export const USER_POPOVER_DELAY = 200;
